import { gql } from '@apollo/client';
import { mutate } from '../../../../../../common/graphql';
import { GET_MY_SUBMISSION_QUERY } from '../submission-graphql';

const DELETE_GAME_BUILD = gql`
  mutation deleteGameBuild($input: DeveloperGameBuildDeleteInput!) {
    developerGameBuildDelete(input: $input) {
      id
    }
  }
`;
interface DeleteGameBuildMutation {
  developerGameBuildDelete: DeleteGameBuildResult;
}

interface DeleteGameBuildResult {}

interface DeveloperGameBuildDeleteInput {
  id: string;
}

export function deleteGameBuild(input: DeveloperGameBuildDeleteInput, submissionId: string) {
  return mutate<DeveloperGameBuildDeleteInput, DeleteGameBuildMutation>(DELETE_GAME_BUILD, input, {
    refetchQueries: [{ query: GET_MY_SUBMISSION_QUERY, variables: { id: submissionId } }],
  });
}
